export enum PersonFlag {
    ProfileEditDismissed = "ProfileEditDismissed",
    ShellTourDismissed = "ShellTourDismissed",
    AiTourDismissed = "AiTourDismissed",
    RanActiveMeetingTour = "RanActiveMeetingTour",
    RanHealthCheckPageTour = "RanHealthCheckPageTour",
    BlurPrivateActions = "BlurPrivateActions",
    UseLegacyObjectiveCreation = "UseLegacyObjectiveCreation",
    CoachSessionDismissed = "CoachSessionDismissed",
    MeetingCalendarIntegrationDismissed = "MeetingCalendarIntegrationDismissed",
    ThemePromptDismissed = "ThemePromptDismissed",
}

// functions called for each flag to check if they should be default enabled
export const PersonFlagDefaults: { [k in PersonFlag]?: () => boolean } = {
    [PersonFlag.BlurPrivateActions]: () => false,
};
